import policy from '../policy/ru'
import terms from '../terms/ru'
import { seoMeta, seoMetaByFile } from '@/seo/pages'

export default {
  app: {
    // Мета страниц с пререндером приходит из реестра src/seo/pages.js — того же,
    // из которого генерится public/seo/*.html. Так статика и приложение не могут
    // разойтись: это один объект, а не две копии. Остальные страницы пререндера
    // не имеют, их тексты лежат тут же ниже.
    ...seoMeta('/'),
    titlePostfix: {
      methods: 'Выбор метода',
      transfer: 'Метод Трансфер',
      logpass: 'Метод LogPass',
      premium: 'Метод Премиум LOG+PASS',
      payment: 'Пополнение',
      profile: 'Профиль'
    },
    purchase: {
      title: 'Купить робуксы Роблокс дёшево на RbxPier.me',
      description:
        'Купить робуксы Роблокс дёшево на RbxPier.me  Покупай робуксы трансфер и подарочные карты Роблокс быстро,' +
        ' дёшево и безопасно. Надёжный сайт с реальными отзывами. Не упусти акции Пристани Робуксов!'
    },
    // Витрины с пререндером — из реестра src/seo/pages.js. Тексты финальные,
    // копирайт по RBXGD-1086; правятся там же, в одном месте на SPA и статику.
    transfer: seoMeta('/transfer'),
    giftcards: seoMeta('/giftcards'),
    superpass: seoMeta('/superpass'),
    packs: seoMeta('/packs'),
    // Пререндера не имеют: метод либо выключен у поставщика, либо страница
    // редиректит. Тексты живут здесь.
    methods: {
      title: 'Способы покупки робуксов Роблокс на RbxPier.me',
      description:
        'Все способы купить робуксы на RbxPier.me: трансфер, подарочные карты, Супер-пасс и робукс паки. Сравни курсы и выбери подходящий метод покупки.'
    },
    premium: {
      title: 'Купить Роблокс Премиум на RbxPier.me',
      description:
        'Купить подписку Roblox Premium на RbxPier.me — активация на твой аккаунт, выгодная цена и безопасная оплата. Надёжный сервис с 2018 года.'
    },
    logpass: {
      title: 'Купить робуксы методом LogPass на RbxPier.me',
      description:
        'Купить робуксы Роблокс методом LogPass на RbxPier.me — зачисление на аккаунт по логину и паролю, выгодный курс и гарантия безопасности сделки.'
    },
    fastpass: {
      title: 'Купить робуксы методом FastPass на RbxPier.me',
      description:
        'Купить робуксы Роблокс методом FastPass на RbxPier.me — быстрое зачисление на аккаунт без долгого ожидания. Выгодный курс и безопасная оплата.'
    },
    termsofuse: seoMeta('/termsofuse'),
    // Юридические страницы тоже из реестра: после RBXGD-1114 у них есть
    // пререндер, и держать тексты в двух местах значит гарантированно их
    // разойтись — ровно тот дубль, из-за которого заводился RBXGD-1094.
    privacy: seoMeta('/privacy'),
    contacts: seoMeta('/contacts'),
    payment: {
      title: 'Пополнение баланса для покупки робуксов на RbxPier.me',
      description:
        'Пополняйте баланс, чтобы быстро и удобно купить робуксы для аккаунта Роблокс. Моментальное зачисление и безопасные способы оплаты: МИР, СБП, VISA, MASTERCARD'
    },
    history: {
      title: 'История покупок пользователя на RbxPier.me',
      description: 'Отслеживайте историю и статус заказов на робуксы.'
    },
    notFound: seoMetaByFile('404.html'),
    serviceUnavailable: {
      title: 'Сервис временно недоступен (503) | RbxPier.me',
      description:
        'Магазин временно недоступен. Мы уже работаем над решением проблемы. Попробуйте обновить страницу через несколько минут.'
    }
  },
  navigation: {
    title: 'Навигация',
    home: 'ГЛАВНАЯ',
    logoText: 'Работаем с 2018 г.',
    buyRobux: 'КУПИТЬ РОБУКСЫ',
    gift: 'ПОДАРОЧНЫЕ КАРТЫ',
    superPass: 'ПОКУПКА СУПЕР-ПАССА',
    packs: 'РОБУКС ПАКИ',
    lk: 'ЛИЧНЫЙ КАБИНЕТ',
    vk: 'Группа ВК',
    discord: 'Дискорд',
    telegram: 'Телеграм',
    instagram: 'Инстаграм',
    tiktok: 'Тикток',
    info: 'ИНФОРМАЦИЯ',
    account: 'АККАУНТ',
    about: 'О нас',
    login: 'Войти',
    dropdown: {
      history: 'История',
      changePassword: 'Сменить пароль',
      refill: 'Пополнить',
      logout: 'Выход',
      copyId: 'Копировать ID',
      copyIdBase: 'Copy ID'
    }
  },
  general: {
    warning: 'Внимание!',
    success: 'Успешно',
    error: 'Ошибка',
    // Подпись неактивной карточки метода на главной (RBXGD-1109). Ключ общий,
    // а не в packs: недоступным может оказаться любой метод.
    temporarilyUnavailable: 'Временно недоступно',
    gotIt: 'Понятно',
    confirm: 'ПОДТВЕРЖДЕНИЕ',
    or: 'или',
    link: 'здесь',
    transfer: 'трансфер',
    gifts: 'подарочные карты',
    superPass: 'супер-пасс',
    packs: 'робукс паки',
    policy: 'ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ',
    terms: 'ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ',
    copied: 'ID скопирован в буфер обмена',

    errors: {
      internal: 'Внутренняя ошибка, пожалуйста, повторите попытку позже',
      server: 'Серверная ошибка'
    }
  },
  actions: {
    continue: 'Продолжить',
    back: 'Назад',
    submit: 'ПОДТВЕРДИТЬ',
    buyRobux: 'КУПИТЬ РОБУКСЫ',
    openDiscord: 'ПЕРЕЙТИ В ДИСКОРД',
    openInstruction: 'ПЕРЕЙТИ В ИНСТРУКЦИЮ',
    createAccount: 'Создать аккаунт',
    login: 'ВОЙТИ В АККАУНТ',
    loginVK: 'Войдите с помощью ВКонтакте',
    signin: 'Войдите',
    enterPassword: 'Введите его',
    skip: 'Пропустить',
    buy: 'Приобрести',
    buyOrder: 'Купить',
    tryAgain: 'Повторить еще раз',
    create: 'Создать',
    ready: 'Готово',
    edit: 'Настроить',
    apply: 'Применить',
    remove: 'Удалить',
    participate: 'Участвовать',
    try: 'Попробовать',
    watch: 'Посмотреть',
    subscribe: 'Подписаться',
    open: 'Открыть',
    close: 'Закрыть',
    promocode: {
      default: 'Промокод не применен',
      success: 'Промокод применен',
      error: 'Не удалось применить',
      minError: 'Мин. сумма покупки {min} R$',
      maxError: 'Макс. сумма покупки {max} R$',
      isNoPromo: 'Промокод не существует!',
      promoExpired: 'Время действия кода истекло!',
      promoMaxUsage: 'Время действия кода истекло!',
      notAuth: 'Требуется авторизация!',
      reuse: 'Код использован ранее!',
      min: 'Мин',
      max: 'Макс'
    },
    chooseMethod: 'ВЫБЕРИ МЕТОД ПОКУПКИ '
  },
  payment: {
    refill: 'Пополнение баланса',
    total: 'Итог',
    toPay: 'К оплате',
    pay: 'ОПЛАТИТЬ',
    makeOrder: 'Оплатить заказ',
    otherPaymentMethods: 'Прочие способы оплаты',
    enterSum: 'Введите сумму пополнения',
    commission: 'Комиссия',
    notEnough: 'У вас недостаточно средств для оплаты!',
    problems: 'В случае возникновения проблем напишите в нашу {support}',
    support: 'службу поддержки',
    selectPaymentMethod: 'ВЫБЕРИТЕ ПЛАТЕЖНЫЙ МЕТОД',
    replenishmentAmount: 'Сумма пополнения:',
    email: 'E-mail:',
    subTitle: 'ПРОВЕРЬТЕ ДАННЫЕ:',
    errors: {
      server: 'Не удалось выполнить пополнение. Попробуйте позже',
      empty: 'Выберите платежный метод для оплаты'
    }
  },
  order: {
    status: 'СТАТУС ЗАКАЗА',
    wait: 'ПОЖАЛУЙСТА, ОЖИДАЙТЕ выполнения заказа',
    waitTime: 'ОСТАЛОСЬ',
    code: 'Код должен состоять из 6 цифр',
    mailCode: 'Введите код с почты',
    makeNewOrder: 'Сделать еще заказ',
    table: {
      nickname: 'ИГРОВОЙ НИК',
      count: 'КОЛ-ВО R$',
      total: 'ИТОГО, РУБ'
    },
    descriptions: {
      wait: 'Ожидайте выполнения заказа',
      notEnoughFunds: 'Заказ не выполнен по технической причине',
      systemError: 'Системная ошибка!',
      checkVip: 'Проверьте настройки VIP ROBLOX!',
      connectionError: 'Ошибка связи с ROBLOX!',
      success: 'Заказ успешно выполнен!',
      checkGamepass: 'Проверьте настройки Gamepass!',
      gift: 'Выдан код подарочной карты',
      passInGame: 'Нажмите, чтобы выполнить \n' + 'необходимое действие!',
      passSuccess: 'Заказ выполнен',
      passWaiting: 'Операция выполняется',
      passCancel: 'Операция отменена',
      error: 'Средства возвращены на баланс'
    },
    cancelReason: {
      noJoin: 'Вы не зашли на сервер',
      noPlay: 'Вы еще ни разу не заходили в игру',
      alreadyBought: 'Вы уже приобрели этот пасс',
      gameError: 'Не получилось подарить пасс',
      serverError: 'Проблема с сервером Roblox',
      other: 'Заказ отменен'
    }
  },
  auth: {
    authorization: 'Авторизация',
    registration: 'Регистрация',
    recovery: 'ВОССТАНОВЛЕНИЕ',
    change: 'СМЕНИТЬ ПАРОЛЬ',

    inputs: {
      email: 'Введите E-mail',
      login: 'Введите логин',
      loginOrEmail: 'Введите логин или E-mail',
      currentPassword: 'Текущий пароль',
      newPassword: 'Новый пароль',
      repeatNewPassword: 'Повторите новый пароль',
      password: 'Введите пароль',
      passwordSubmit: 'Подтвердите пароль'
    },

    errors: {
      email: 'Неверный E-mail!',
      incorrectPassword: 'Пароль неверный!',
      empty: 'Поле пустое',
      nicknameIsTooSmall: 'Вы должны указать имя, состоящее не менее чем из 4 символов',
      inactiveEmail: 'Электронная почта недействительна',
      passwordIsTooSmall: 'Ваш пароль должен иметь от 6 до 18 символов',
      passwordNotMatch: 'Пароли не совпадают',
      oneUppercase: 'Ваш пароль должен иметь хотя бы одну заглавную букву',
      userExist: 'Пользователь с такими данными уже существует',
      checkEmail: 'Убедитесь в правильности вашего электронного письма/имени пользователя',
      checkPassword: 'Убедитесь, что ваш пароль верен',
      changePasswordIncorrect: 'Пароль должен быть от 6 до 18 символов и состоять из букв “A-z”!',
      social: 'Не удалось войти. Попробуйте ещё раз или используйте другой способ'
    },

    welcome: {
      title: 'ДОБРО ПОЖАЛОВАТЬ',
      content: 'ЗАРЕГИСТРИРУЙТЕСЬ НА НАШЕМ САЙТЕ И НАЧНИТЕ ПОКУПАТЬ РОБУКСЫ НАДЕЖНО, БЫСТРО И БЕЗОПАСНО'
    },

    forget: 'Забыли пароль?',
    remember: 'Вы вспомнили пароль?',
    agreement: 'Я согласен с {policy} и {agreement}',
    privacyPolicy: 'политикой конфиденциальности',
    userAgreement: 'пользовательским соглашением',
    haveAccount: 'У Вас уже есть аккаунт?',
    codeSent: 'На почту {email} отправлен код для восстановления пароля!',
    enterCode: 'Введите 6-ти значный код:',
    requestCode: 'Запросить снова',

    changePasswordSuccess: {
      title: 'Отлично!',
      content: 'Вы успешно изменили пароль! Обязательно запомните...'
    }
  },
  slider: {
    // slide1: {
    //   title: 'НАМ ДОВЕРЯЮТ БЛОГЕРЫ',
    //   content: 'ЗА ШЕСТЬ ЛЕТ СУЩЕСТВОВАНИЯ САЙТА СОТНИ ТЫСЯЧ ЗАКАЗОВ. ПОКУПАЙ БЕЗОПАСНО В ПРОВЕРЕННОМ МАГАЗИНЕ'
    // },
    // slide1: {
    //   title: 'БОЛЬШЕ ВОЗМОЖНОСТЕЙ',
    //   content: 'ТЕПЕРЬ МОЖНО СОВЕРШИТЬ ПОКУПКУ от <span class="active-text sm">20 РОБУКСОВ</span>\n' +
    //     'И ПОПОЛНЕНИЕ от <span class="active-text sm">10 РУБЛЕЙ</span>'
    // },
    slide1: {
      title: 'Встречай подарочные карты!',
      content:
        'Купи подарочную карту и получи <br><span class="active-text sm">робуксы мгновенно!</span> Есть шанс получить уникальные предметы при покупке от 800 робуксов!'
    },
    slide2: {
      title: 'БЫСТРАЯ ДОСТАВКА!',
      content: 'Начисляем робуксы в pending <span class="active-text sm">в течение 1 минуты</span> после оплаты!'
    },
    slide3: {
      title: 'ВСЁ ЕЩЁ СОМНЕВАЕШЬСЯ?',
      content:
        'ТЫСЯЧИ ДОВОЛЬНЫХ КЛИЕНТОВ <span class="active-text sm">С РЕАЛЬНЫМИ ОТЗЫВАМИ</span> В НАШИХ СОЦИАЛЬНЫХ СЕТЯХ!'
    },
    slide4: {
      title: 'РОЗЫГРЫШ НА <span class="active-text"> 30 000 РОБУКСОВ!</span>',
      content: 'Ты всё ещё не участвуешь?  Тогда выиграет кто-то другой'
    },
    slide5: {
      title: 'Встречай метод Супер-пасс!',
      content:
        '<span class="active-text sm">Моментальная доставка</span> пассов для игр Роблокс по еще более выгодному курсу!'
    }
  },
  faq: {
    title: 'Cтань лучшим игроком в Роблокс!',
    items: {
      item1: {
        title: 'УЧАСТВУЙ В РОЗЫГРЫШЕ!',
        content: 'Не упусти бесплатные робуксы, мега-промокоды, ивенты!',
        button: 'Подписаться'
      },
      item2: {
        title: 'ПРИСТАНЬ РОБУКСОВ',
        content: '400+ тысяч клиентов, всегда лучший курс, выполняем быстро каждый заказ',
        button: 'Хочу тоже!'
      },
      item3: {
        title: 'ЗАСЛУЖИВАЕМ ДОВЕРИЯ ',
        content: 'Нас проверили блогеры и время! Стараемся ради каждого пользователя!'
      }
    }
  },
  help: {
    title: 'ВОЗНИКЛИ ВОПРОСЫ ПО ПОКУПКЕ?',
    text1:
      'Онлайн-поддержка с живыми операторами поможет вам ежедневно с 7:00 до 23:00 по московскому времени. Для обращения нажмите на виджет поддержки в правом нижнем углу экрана.',
    text2: 'Ознакомиться с инструкцией по покупке можно'
  },
  footer: {
    privacy: 'ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ',
    terms: 'ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ',
    contacts: 'КОНТАКТНАЯ ИНФОРМАЦИЯ'
  },
  partnership: {
    title: 'Сотрудничество',
    info: 'Мы предлагаем выгодное сотрудничество для блогеров'
  },
  methods: {
    title: 'КАКИМ СПОСОБОМ ПОКУПКИ ВЫ ХОТИТЕ ВОСПОЛЬЗОВАТЬСЯ?',
    hintError: {
      title: 'Ошибка!',
      content: 'У вас уже есть Роблокс Премиум!'
    },
    method: 'Метод',
    robux: 'Робуксы',
    pass: 'Пропуск',
    premium: 'Премиум',
    transfer: 'Трансфера',
    logpass: 'log+pass',
    available: 'Есть в наличии',
    notAvailable: 'Нет в наличии'
  },
  cookie: {
    whatIsCookie: 'Что такое COOKIE?',
    checkInstruction: 'ОЗНАКОМЬТЕСЬ С COOKIE-ИНСТРУКЦИЕЙ',
    enter: 'Введите Cookie',
    description: {
      part1:
        'Сами по себе куки не опасны — это обычные текстовые файлы. Они не могут запускать процессы на компьютере и вообще взаимодействовать с операционной системой. Но их могут попытаться перехватить или украсть, чтобы отследить ваши предыдущие действия в сети или входить в ваши аккаунты без авторизации.',
      part2:
        'Обычно информацию, которую записывают в куки, зашифровывают перед отправкой, а сами куки передают по HTTPS-протоколу. Это помогает защитить пользовательские данные, но за внедрение шифрования и безопасную отправку отвечает разработчик сайта. Посетителям остаётся только надеяться, что всё настроили грамотно. Со своей стороны пользователь может только запретить браузеру использовать куки или время от времени чистить их самостоятельно.'
    }
  },
  calculator: {
    title: 'У НАС ЛУЧШИЙ КУРС',
    robux: 'Робуксы',
    pass: 'Пропуск',
    youPay: 'Ты платишь',
    youGet: 'Ты получишь'
  },
  transfer: {
    title: 'Покупка методом трансфер',
    titleMobile: 'Покупка робуксов',
    titleSmall: 'Трансфер',
    subTitle: 'Срок поступления робуксов на счет 5 дней',
    subTitleIncreaseTime: 'После этого срок поступления робуксов на счет 5 дней.',
    charactersTitle: 'Введите никнейм',
    charactersSubTitle: 'Выберите своего персонажа из списка',
    placeTitle: 'Выбери свой place',
    paymentSubTitle: 'Ещё раз перед оплатой проверьте все данные',
    robuxDelivery: 'Робуксы будут зачислены в течении 5 дней (120 часов)',
    available: 'В наличии:',
    robuxCount: 'Количество робуксов',
    minumum: 'Минимум от {min} R$',
    nickname: 'Игровой никнейм',
    notFound: 'Ничего не найдено',
    checkPlaces: 'ПРОВЕРЬТЕ ПОЖАЛУЙСТА, ЧТО У ВАС СОЗДАН ХОТЯ БЫ 1 ПЛЕЙС, КОТОРЫЙ ЯВЛЯЕТСЯ ПУБЛИЧНЫМ',
    vipPrice: 'Установите цену VIP сервера на {price}',
    changePrice: 'Изменить цену',
    orderSuccess: 'Отслеживать поступление робуксов на ваш аккаунт вы можете {here}',
    orderError: 'Средства возвращены на баланс аккаунта ROBUXPIER. Попробуйте еще раз :)',
    here: 'здесь',
    promoSwitch: 'У меня есть промокод',
    promoInfo: 'Где взять промокод?',
    benefits: {
      1: 'Классический метод',
      2: 'Дешёвые робуксы'
    },
    gamepass: {
      checkData: 'Проверьте корректность данных в Gamepass!',
      creating: 'СОЗДАНИЕ',
      settingUp: 'НАСТРОЙКА',
      createGamepass: 'Создайте Game-pass',
      checkInstruction: 'Посмотрите инструкцию и установите цену <span class="text-color--blue">{price} R$</span>',
      checkInstructionNew: 'Внимательно посмотрите инструкцию',
      serverError: 'Проверьте, что геймпасс создан',
      setPrice: 'Установите цену',
      success: 'Успешно!',
      successHint: 'Данный геймпасс уже настроен! Если вы хотите изменить сумму, то пожалуйста начните покупку заново!',
      regionalPriceHint:
        'Уберите галочку "Enable regional pricing" ("Включить региональное ценообразование") и попробуйте снова!'
    },
    errors: {
      insufficientBalance: 'Недостаточно средств на балансе',
      notAuthorized: 'Вы не авторизованы',
      serverError: 'Ошибка на сервере',
      robuxNotAvailable: 'Количество робаксов недоступно для покупки',

      priceNotNumber: 'Цена должна быть числом',
      robuxMinimum: 'Нельзя заказать менее {robux} робаксов',
      robuxMaximun: 'Максимальная сумма покупки временно ограничена 5k R$',
      halfBalance: 'Нельзя заказать больше половины баланса: {balance} робаксов',
      emptyBalance: 'На сайте закончились робуксы, ожидайте пополнение',
      robuxMustDivide:
        'R$ должно делиться на {orders}. Попробуйте <span class="min">{closestMin}R$</span> или <span class="max">{closestMax}R$</span>',
      emptyCharacters: 'Введите никнейм Вашего персонажа и выберите его из списка'
    },
    timeIncreased: 'Время выдачи увеличено.',
    selectYourPlace: 'Выберите свой',
    setNumberRobux: 'Установите количество робуксов',
    chooseNumberRobux: 'Выберите количество робуксов'
  },
  gift: {
    title: 'Покупка подарочной карты',
    titleMobile: 'Покупка гифт-карты',
    name: 'Гифт-карты',
    titleSmall: 'Подарочные карты',
    badge: 'Моментальная доставка!',
    infoText:
      'Все спорные вопросы по применению подарочных кодов рассматриваются поддержкой ТОЛЬКО при предоставлении видеозаписи без монтажа ОТ МОМЕНТА ПОКУПКИ подарочного кода ДО МОМЕНТА ПРОВЕРКИ кода на сайте Roblox.',
    balanceError: 'Недостаточно средств на балансе',
    benefits: {
      1: 'Мгновенная доставка',
      2: 'Можно подарить другу'
    },
    errors: {
      empty: 'Выберите подарочную карту'
    }
  },
  packs: {
    title: 'Покупка робукс пака',
    titleMobile: 'Покупка робукс пака',
    titleSmall: 'Робукс паки',
    course: 'Выгодный курс',
    badge: 'Быстрая выдача!',
    robuxCards: 'Робукс паки',
    premiumSubscription: 'Premium подписка',
    noProducts: 'Паки временно недоступны, ожидайте пополнение',
    payFromBalance: 'Оплатить с баланса',
    cost: 'Стоимость заказа',
    balanceHint: 'На балансе: {balance}',
    infoText:
      'Все спорные вопросы по выдаче робуксов рассматриваются поддержкой ТОЛЬКО при предоставлении видеозаписи без монтажа ОТ МОМЕНТА ОПЛАТЫ заказа ДО МОМЕНТА ПРОВЕРКИ баланса на сайте Roblox.',
    benefits: {
      1: 'Робуксы мгновенно',
      2: 'Надежно и безопасно'
    },
    consent: {
      label: 'Я согласен на передачу данных аккаунта для успешной доставки',
      hint:
        'Мы используем данные аккаунта (пароль и резервный код) только для оформления заказа. ' +
        'Мы не сохраняем эти данные и применяем защищённые методы для их обработки, ' +
        'потому что заботимся о твоей безопасности.'
    },
    errors: {
      selectPack: 'Выберите робукс пак',
      consent: 'Подтвердите согласие на передачу данных аккаунта',
      auth: 'Ошибка авторизации, войдите в аккаунт заново',
      product: 'Не удалось получить товар, попробуйте выбрать другой пак',
      amount: 'Этот номинал робуксов недоступен для покупки',
      balance: 'Недостаточно средств на балансе',
      updateForbidden: 'Заказ уже нельзя изменить, обратитесь в поддержку'
    },
    wizard: {
      title: 'Выдача заказа',
      subtitlePrefix: 'Чтобы получить заказ',
      subtitleSuffix: 'нужно выполнить несколько простых действий:',
      amount: '{count} робуксов',
      securityText:
        'Мы дорожим своей репутацией, нигде не сохраняем пароли и гарантируем 100% безопасность твоего аккаунта.',
      step1Title: 'Укажи пароль от Роблокс',
      step1Button: 'Готово',
      passwordPlaceholder: 'Пароль',
      step2Title: 'Привяжи электронную почту',
      step2Text: 'Для отправки резервных кодов нужно привязать электронную почту. Посмотри инструкцию как это сделать.',
      step2Link: 'Перейти в Роблокс',
      step2Button: 'Я привязал почту',
      step3Title: 'Введи резервные коды',
      step3Text:
        'Включи двухэтапную аутентификацию через почту и сгенерируй резервные коды. Они нужны, чтобы мы могли доставить твой заказ.',
      step3Link: 'Перейти в Роблокс →',
      code1Placeholder: 'Резервный код 1',
      code2Placeholder: 'Резервный код 2',
      codeError: 'Код должен содержать 9 символов',
      step3Button: 'Отправить коды',
      videoBtn: 'Видео-инструкция',
      helpBtn: 'Помощь',
      usernameCopied: 'Никнейм скопирован'
    },
    videoModal: {
      title: 'Видео-инструкция',
      placeholder: 'Видео-инструкция скоро будет добавлена',
      timecodes: {
        security: 'Безопасность',
        email: 'Привязка почты',
        codes: 'Резервные коды'
      }
    },
    verification: {
      title: 'Выдача заказа',
      description:
        'Чтобы мы смогли выполнить твой заказ, перейди по ссылке и выбери игры, в которые ты заходил с аккаунта',
      waiting: 'После выбора игр вернись на эту страницу — мы продолжим обработку заказа автоматически.',
      button: 'Перейти к выбору игр',
      helpBtn: 'Помощь'
    },
    processing: {
      title: 'Обработка заказа',
      text: 'Твой заказ скоро будет выполнен!',
      note:
        'В целях безопасности <b>не меняйте пароль и не выходите из аккаунта</b> до завершения выдачи робуксов.',
      track: 'Отслеживать поступление робуксов вы можете {here}'
    },
    history: {
      empty: 'У вас пока нет заказов робукс паков',
      actionRequired: 'Необходимо действие',
      waitingPayment: 'Ожидает оплаты',
      verification: 'Выбрать игры'
    }
  },
  superPass: {
    title: 'Супер-пасс',
    games: {
      title: 'Выбери игру',
      subTitle: 'Нет нужной игры? Обратись',
      support: ' в поддержку',
      placeholder: 'Введите название игры для поиска',
      neededGame: 'Чтобы получить пасс для выбранной игры, вам понадобится зайти в игру после оплаты.',
      withoutGame: 'Вам не нужно будет заходить в игру, чтобы получить пасс.'
    },
    pass: {
      title: 'Выбери пасс',
      placeholder: 'Искать пасс',
      salesHit: 'Хит продаж'
    },
    purchase: {
      title: 'Покупка супер-пасса',
      subTitle: 'Ещё раз перед оплатой проверьте данные',
      activeOrder: 'Дождитесь, пока не выполнится предыдущий заказ методом Суперпасса.'
    },
    empty: {
      game: 'Не нашли такую игру в нашем списке',
      gameLink: 'Чтобы мы добавили новую игру в список, \n' + 'отправьте нашей поддержке ссылку на нее!',
      passSearch: 'Не нашли такой пасс в нашем списке',
      pass: 'Пассы для этой игры еще не добавлены. \n' + 'Мы уже работаем над их добавлением!\n'
    },
    timer: {
      title: 'Почти готово!',
      subTitle: 'Для получения заказа вам будет необходимо войти в игру! Пожалуйста, следуйте инструкции:',
      left: 'Осталось',
      warningText: 'Пожалуйста поспешите, наш специалист может ожидать Вас только ограниченное время!',
      step: {
        first: {
          title: 'Дождитесь своей очереди'
        },
        second: {
          title: 'Присоединитесь к игре и получите пасс',
          user: 'Пользователь, который подарит выбранный пасс:',
          action: 'Перейдите на страницу аккаунта и нажмите кнопку',
          redirectToAccount: 'Перейти на страницу аккаунта'
        }
      },
      statuses: {
        ready: 'Готово',
        waiting: 'Наш специалист ожидает Вас в игре',
        freeSoon: 'Наш специалист скоро освободится',
        startingOrder: 'Наш специалист приступает к вашему заказу',
        launchingGame: 'Наш специалист запускает игру',
        preparingPass: 'Наш специалист подготавливает пасс',
        timeIncreased: 'Из-за высокой нагрузки время выдачи заказа увеличено'
      }
    },
    timeInfo: {
      title: 'Покупка супер-пасса',
      description:
        'Этот метод работает с <strong>10:00 до 24:00</strong> по Московскому времени. ' +
        'Пожалуйста, повтори попытку утром.',
      anotherMethod: 'Купить робуксы другим способом'
    },
    stockInfo: {
      title: 'Повторите попытку позже',
      description:
        'В данный момент ведутся техническое работы, мы возобновим метод как можно быстрее! Пожалуйста, повторите попытку заказа позже',
      ok: 'Хорошо'
    },
    benefits: {
      1: 'Мгновенная доставка',
      2: 'Пассы для Роблокса'
    },
    errors: {
      emptyGame: 'Выберите игру',
      emptyPass: 'Выберите пасс'
    }
  },
  logpass: {
    enterNickname: 'ВВЕДИТЕ НИКНЕЙМ',
    buyRobuxTitle: 'ПОКУПКА робуксов',
    codes: {
      code_request: 'Пожалуйста, введите код, который пришел Вам на почту',
      order_awaiting: 'Ожидайте выполнение заказа',
      code_request_awaiting: 'Ожидайте запрос кода с почты',

      password_error: 'Неверный пароль в ROBLOX',
      code_error: 'Неверный код двухэтапной аутентификации из почты',
      cookie_error: 'Ошибка. Неверные данные для авторизации',
      email_timeout_error: 'Вы не указали код! Повторите заказ и постарайтесь ввести код как можно быстрее!',
      error: 'Ошибка. Попробуйте еще раз',
      success: 'Заказ успешно выполнен',
      waiting: 'Ожидайте выполнения заказа'
    }
  },
  premium: {
    buyPremium: 'ПОКУПКА ПРЕМИУМА',
    alreadyExist: 'У вас уже есть Роблокс Премиум!',
    subscribe: {
      title: '{percent} К РОБУКСАМ!',
      subtitle: 'с Премиум подпиской вы получите больше робуксов '
    },
    getRbx: 'Получи {rbx} на счет',
    buyWithProfit: 'ПОКУПАЙ С ВЫГОДОЙ!',
    currencyPerMonth: '{currency} на месяц',
    toPay: 'Итого к оплате: ',
    premiumTime: 'Премиум подписка покупается только на {time}',
    oneMonth: '1 месяц без автопродления',
    enterPromocode: 'Введите промокод',
    ordering: 'ОФОРМЛЕНИЕ ЗАКАЗА',
    mailCode: 'ОЖИДАЙТЕ ЗАПРОС КОДА С ПОЧТЫ',

    correctSum: 'Введите корректную сумму',
    minRefillSum: 'Сумма пополнения должна быть не менее 5 рублей'
  },
  fastpass: {
    characters: {
      inventory: 'Необходимо открыть ваш инвентарь в настройках приватности!'
    },
    instruction: {
      plugin: 'ПЛАГИНА',
      mobileError:
        'Приносим свои извинения, но создать плагин с телефона невозможно.\n\nПожалуйста, воспользуйтесь компьютером.',
      checkPlugin: 'Проверьте корректность данных в ПЛАГИНЕ!',
      create: 'СОЗДАНИЕ',
      edit: 'НАСТРОЙКА',
      select: 'ВЫБОР',
      createSubtitle: 'Посмотрите инструкцию и выполните все указанные действия. Укажите цену',
      editSubtitle: 'Проведите настройку Вашего плагина. Укажите цену',
      selectSubtitle: 'Выберите плагин, который хотите использовать',
      actions: {
        create: 'СОЗДАТЬ ПЛАГИН',
        edit: 'НАСТРОИТЬ ПЛАГИН'
      }
    }
  },
  supportChat: {
    hint: 'У тебя есть вопрос?',
    title: 'ПОДДЕРЖКА ИГРОКОВ',
    titleSm: 'ПОДДЕРЖКА',
    operator: 'Ваш помощник',
    actions: 'Варианты действий',
    anket: 'Представьтесь, чтобы связаться с оператором. Вам обязательно ответят на вопросы, связанные с RobuxPier.',
    name: 'Имя',
    email: 'E-mail',
    vk: 'Ссылка на Вконтакте',
    send: 'Отправить',
    enterMessage: 'Введите сообщение...'
  },
  qiwi: {
    details: 'ДЕТАЛИ ПОПОЛНЕНИЯ',
    passport: 'У Вас есть Паспорт РФ?',
    noPassport: 'Так как у Вас нет Паспорта РФ, Вы не сможете пройти верификацию в платежной системе Qiwi.',
    hasPassport: 'Вам необходимо пройти верификацию на сайте Qiwi, чтобы комиссия была меньше.',
    noPassportCommission: 'Комиссия будет составлять 7.5%',
    hasPassportCommission: 'Комиссия будет составлять 3%',
    yes: 'Да',
    no: 'Нет'
  },
  history: {
    nickname: 'Никнейм',
    sumRobux: 'Сумма, R$',
    sumRub: 'сумма',
    status: 'Статус',
    description: 'Описание',
    timer: 'Таймер',
    time: 'Время',
    game: 'Игра',
    pass: 'Пасс',
    passClick: 'Нажмите',
    method: 'Метод',

    error: 'Ошибка',
    wait: 'Ожидание',
    success: 'Успешно',
    orderCount: 'Показаны {order} из {length} записей',
    pendingInfo: 'Отслеживать поступление робуксов',
    giftInfo: 'Выдан код'
  },
  modals: {
    feedback: {
      title: 'Нравится наш сайт?',
      text:
        'Пожалуйста, напишите хороший отзыв о нашем сайте! Он поможет радовать Вас низкими ценами и надежной доставкой!',
      submit: 'Оставить отзыв'
    },
    // Вариант для Яндекс.Браузера (RBXGD-1111): отзыв в карточке сайта у
    // Яндекса растит доверие именно в его выдаче, а она даёт нам половину
    // органики. Показывается вместо feedback, когда в UA есть YaBrowser.
    reviewYandex: {
      title: 'Оставьте отзыв в Яндексе',
      text:
        'Вам понравился наш сайт? Оставьте, пожалуйста, отзыв в карточке сайта — это поможет другим покупателям и нам.',
      submit: 'Оставить отзыв'
    },
    social: {
      title: 'Что тут у нас?',
      text: 'Промокоды, розыгрыши, мемы и новости — причины подписаться на наши социальные сети.'
    },
    partnership: {
      title: 'Сотрудничество',
      text:
        'Если вы блогер и собираете стабильно от 3000 просмотров напишите в телеграмм нашему менеджеру в <span class="active">Telegram</span>',
      submit: '@Arina89731'
    },
    promocode: {
      title: 'Где взять промокод?',
      text: 'Подпишись на наши социальные сети, мы там регулярно публикуем выгодные промокоды!'
    },
    gift: {
      title: 'Ваш код подарочной карты',
      text: 'Скопируйте подарочный код и введите его на сайте Roblox.  Вы можете снова открыть код в истории платежей',
      submit: 'ПЕРЕЙТИ НА САЙТ ROBLOX',
      copied: 'Код подарочной карты скопирован'
    },
    place: {
      title: 'НЕТ НУЖНОГО ПЛЕЙСА?',
      text:
        'Чтобы выбрать нужный Вам плейс, Вы должны подтвердить отсутствие в нем запрещенного контента. Это новое требование от Роблокса. При следующих покупках с выбором вашего плейса проходить опрос еще раз не нужно.',
      textMob:
        'Для выбора плейса необходимо подтвердить, что в нём нет запрещённого контента (новое требование Роблокса). Это нужно сделать только при первой покупке.',
      submit: 'ПЕРЕЙТИ НА САЙТ ROBLOX',
      subText: 'Пожалуйста, ознакомьтесь с инструкцией ниже и пройдите опрос от Роблокса.',
      subTextMob: 'Пожалуйста, пройдите опрос от Роблокса по инструкции ниже.',
      continue: 'Продолжить',
      help: 'Помощь',
      notification:
        'Убедитесь, что вы полностью прошли опрос и нужный Вам плейс получил статус "Public" ("Публичный").  Если вы уверены, то начните покупку заново.',
      notificationMob:
        'Убедитесь, что вы полностью прошли опрос и нужный Вам плейс получил статус "Public" ("Публичный").'
    }
  },
  // Заголовки самих страниц-заглушек (не мета). По ТЗ RBXGD-1086 они должны
  // совпадать с H1 в пререндере: у робота и у человека одна и та же страница.
  notFound: {
    title: 'Упс, страница не найдена…',
    description: 'Попробуйте перезагрузить страницу, или вернитесь на главную страницу сайта ',
    button: 'Вернуться на главную'
  },
  serviceUnavailable: {
    title: 'Сервис временно недоступен',
    description: 'Магазин временно недоступен. Мы уже работаем над решением проблемы. Попробуйте обновить страницу через несколько минут.',
    button: 'Обновить страницу'
  },
  policy,
  terms
}
